import { getConfig } from '../config'
/**
 *  <script type="text/javascript" src="https://cdn-apac.onetrust.com/consent/143b3991-7879-4a35-974e-5e4c03d02339/OtAutoBlock.js" ></script>
    <script src="https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="143b3991-7879-4a35-974e-5e4c03d02339" ></script>
    <script type="text/javascript">
    function OptanonWrapper() { }
    </script>
 */
export const initCookieProtocol = () => {
  if (getConfig().legalTerms.enabledCookieTips) {
    const docFrag = new DocumentFragment()
    const scriptAutoBlock = document.createElement('script')
    scriptAutoBlock.setAttribute('type', 'text/javascript')
    scriptAutoBlock.setAttribute('src', 'https://cdn-apac.onetrust.com/consent/01908202-3640-7135-a309-12f709935ad8/OtAutoBlock.js')
    // dev环境脚本
    // scriptAutoBlock.setAttribute('src', 'https://cdn-apac.onetrust.com/consent/01908202-3640-7135-a309-12f709935ad8-test/OtAutoBlock.js')
    const scriptSDK = document.createElement('script')
    scriptSDK.setAttribute('src', 'https://cdn-apac.onetrust.com/scripttemplates/otSDKStub.js')
    scriptSDK.setAttribute('type', 'text/javascript')
    scriptSDK.setAttribute('charset', 'UTF-8')
    scriptSDK.setAttribute('data-domain-script', '01908202-3640-7135-a309-12f709935ad8')
    // dev环境脚本
    // scriptSDK.setAttribute('data-domain-script', '01908202-3640-7135-a309-12f709935ad8-test')

    docFrag.appendChild(scriptAutoBlock)
    docFrag.appendChild(scriptSDK)

    document.head.insertBefore(docFrag, document.head.firstChild)
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookie-protocal.js